<div class="card-container" [class]="theme">
  <div class="title flex-center">{{ cardTitle }}</div>

  <div class="card-body flex-center">
    <div class="data-icon">  
        <span class="material-symbols-outlined">
          {{ cardIcon || cardIconMap[theme] || 'thumb_up' }}
        </span>
    </div>
    <div class="data-value">{{ dataValue }}</div>
  </div>
</div>

